const ErrorsIcon = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M22.6875 15.4875L14.6625 2.57501C14.025 1.71251 13.05 1.22501 12 1.22501C10.9125 1.22501 9.9375 1.71251 9.33749 2.57501L1.3125 15.4875C0.562496 16.5 0.449996 17.8125 1.0125 18.9375C1.575 20.0625 2.7 20.775 3.975 20.775H20.025C21.3 20.775 22.425 20.0625 22.9875 18.9375C23.55 17.85 23.4375 16.5 22.6875 15.4875ZM21.4875 18.1875C21.1875 18.75 20.6625 19.0875 20.025 19.0875H3.975C3.3375 19.0875 2.8125 18.75 2.5125 18.1875C2.25 17.625 2.2875 16.9875 2.6625 16.5L10.6875 3.58751C10.9875 3.17501 11.475 2.91251 12 2.91251C12.525 2.91251 13.0125 3.13751 13.3125 3.58751L21.3375 16.5C21.7125 16.9875 21.75 17.625 21.4875 18.1875Z'
        fill='#111928'
      />
      <path
        d='M11.9999 8.20003C11.5499 8.20003 11.1374 8.57503 11.1374 9.06253V13.15C11.1374 13.6 11.5124 14.0125 11.9999 14.0125C12.4874 14.0125 12.8624 13.6375 12.8624 13.15V9.02503C12.8624 8.57503 12.4499 8.20003 11.9999 8.20003Z'
        fill='#111928'
      />
      <path
        d='M11.9999 15C11.5499 15 11.1374 15.375 11.1374 15.8625V16.05C11.1374 16.5 11.5124 16.9125 11.9999 16.9125C12.4874 16.9125 12.8624 16.5375 12.8624 16.05V15.825C12.8624 15.375 12.4499 15 11.9999 15Z'
        fill='#111928'
      />
    </svg>
  );
};

export default ErrorsIcon;
